import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters: {
    nextProject ({ currentProject, projectList }) {
      if (!currentProject || !currentProject.ID || !projectList.length) return

      const id = currentProject.ID
      const idx = projectList.findIndex((p) => p.ID === id)
      const wrap = (idx + 1) % projectList.length

      return projectList[wrap]
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js